import { render, staticRenderFns } from "./PackageDefaultKidsDeleteDialog.vue?vue&type=template&id=0547ee33&scoped=true"
import script from "./PackageDefaultKidsDeleteDialog.vue?vue&type=script&lang=js"
export * from "./PackageDefaultKidsDeleteDialog.vue?vue&type=script&lang=js"
import style0 from "./PackageDefaultKidsDeleteDialog.vue?vue&type=style&index=0&id=0547ee33&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0547ee33",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0547ee33')) {
      api.createRecord('0547ee33', component.options)
    } else {
      api.reload('0547ee33', component.options)
    }
    module.hot.accept("./PackageDefaultKidsDeleteDialog.vue?vue&type=template&id=0547ee33&scoped=true", function () {
      api.rerender('0547ee33', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/Package/PackageDefaultKidsDeleteDialog.vue"
export default component.exports